import { render, staticRenderFns } from "./OrdersCurrentlyUnavailable.vue?vue&type=template&id=19784e02&scoped=true"
import script from "./OrdersCurrentlyUnavailable.vue?vue&type=script&lang=js"
export * from "./OrdersCurrentlyUnavailable.vue?vue&type=script&lang=js"
import style0 from "./OrdersCurrentlyUnavailable.vue?vue&type=style&index=0&id=19784e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19784e02",
  null
  
)

export default component.exports